import React from "react";
import { Card, Button } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";

const CardP = ({ name, description, img, url }) => {
  return (
    <div className="cards">
      <Card style={{ maxWidth: "25em", minHeight: "25em" }}>
        <Card.Img
          style={{ maxHeight: "12em", height: "12em" }}
          variant="top"
          src={`${img}`}
          className="card_image"
        />
        <Card.Body className="card_content">
          <Card.Title className="card_title">{name}</Card.Title>
          <Card.Text className="card_text">{description}</Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button className="card_btn" href={`${url}`} target="_blank">
            {<AiFillGithub id="iconGitHub" />}
            Code!.
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default CardP;
